import { render, staticRenderFns } from "./SwitchLanguages.vue?vue&type=template&id=8b34ea34&scoped=true&"
import script from "./SwitchLanguages.vue?vue&type=script&lang=js&"
export * from "./SwitchLanguages.vue?vue&type=script&lang=js&"
import style0 from "./SwitchLanguages.vue?vue&type=style&index=0&id=8b34ea34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b34ea34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b34ea34')) {
      api.createRecord('8b34ea34', component.options)
    } else {
      api.reload('8b34ea34', component.options)
    }
    module.hot.accept("./SwitchLanguages.vue?vue&type=template&id=8b34ea34&scoped=true&", function () {
      api.rerender('8b34ea34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Header/SwitchLanguages.vue"
export default component.exports